import TimetableAdapter from './base';

export default class Period extends TimetableAdapter {
  modelNamePlural = 'periods';

  shouldReloadRecord() {
    return false; // Period records are immutable, so there's never any point reloading if we already have it.
  }

  shouldBackgroundReloadRecord() {
    return false;
  }
}
